// tenantRequests' scopedGet/scopedPost/etc already resolve to the parsed body (the axios
// response interceptor in config.ts returns `response.data`, and `SwaggerResponse<R> = R` is a
// bare alias, not a `{ data: R }` wrapper) — so this only narrows the untyped result, it does
// not unwrap a further `.data` layer.
export const unwrapped = <T>(promise: Promise<unknown>): Promise<T> => promise as Promise<T>;

export const QUERIES = {
  MY_RESTAURANTS: 'myRestaurants',
  RESTAURANT_CURRENCY: 'restaurantCurrency',
  BRANCHES: 'branches',
  MENU: 'menu',
  ORDERS: 'orders',
  RECENT_ORDERS: 'recentOrders',
  DELIVERY_ORDERS: 'deliveryOrders',
  IN_PROGRESS_ORDERS: 'inProgressOrders',
  PAID_ORDER_TOKENS: 'paidOrderTokens',
  MENU_ITEMS: 'menuItems',
  MENU_ITEM_VARIANTS: 'menuItemVariants',
  TABLES: 'tables',
  EMPLOYEES: 'employees',
  EMPLOYEE_SELF: 'employeeSelf',
  TRANSACTION_CATEGORIES: 'transactionCategories',
  EMPLOYEE_RULES: 'employeeRules',
  EMPLOYEE_DAY_OFF: 'employeeDayOff',
  TRANSACTIONS: 'transactions',
  ISSUES: 'issues',
  // Deliberately the SAME string as ISSUES. useCrudResource invalidates on the three-element
  // prefix [key, orgSlug, restaurantId], so a create or delete through the shared modals
  // refetches the lanes too. A distinct string would leave the board stale after every create.
  ISSUE_LANES: 'issues',
  EMPLOYEE_MONTHLY_ISSUES: 'employeeMonthlyIssues',
  EMPLOYEE_MONTHLY_DAY_OFF: 'employeeMonthlyDayOff',
  DASHBOARD_SALES_REPORTS: 'dashboardSalesReports',
  EMPLOYEE_INCOMES: 'employeeIncomes',
  TIMESHEET_ME_CURRENT: 'timesheetMeCurrent',
  TIMESHEET_ME_RANGE: 'timesheetMeRange',
  TIMESHEET_LIST: 'timesheetList',
  TIMESHEET_DETAIL: 'timesheetDetail',
  TIMESHEET_KIOSK_ROSTER: 'timesheetKioskRoster',
  TIMESHEET_HOLIDAYS: 'timesheetHolidays',
  TIMESHEET_CALENDAR: 'timesheetCalendar',
  SCHEDULES: 'schedules',
  SCHEDULE_ME: 'scheduleMe',
  DASHBOARD_ACCOUNTING_REPORTS: 'dashboardAccountingReports',
  AUTH_SESSION: 'authSession',
  MEMBERSHIPS: 'memberships',
  ONBOARDING_STATUS: 'onboardingStatus',
  ORG_MEMBERS: 'orgMembers',
  ORG_INVITATIONS: 'orgInvitations',
  AUDIT_LOG: 'auditLog',
  ADMIN_ORGANIZATIONS: 'adminOrganizations',
  ADMIN_USERS: 'adminUsers',
  INVENTORY_ITEMS: 'inventoryItems',
  INVENTORY_ITEMS_ALL: 'inventoryItemsAll',
  INVENTORY_MOVEMENTS: 'inventoryMovements',
  INVENTORY_CATEGORIES: 'inventoryCategories',
  INVENTORY_STOCK_LEVELS: 'inventoryStockLevels',
  DASHBOARD_INVENTORY_REPORTS: 'dashboardInventoryReports',
  DASHBOARD_STAFF_REPORTS: 'dashboardStaffReports',
  DASHBOARD_ISSUE_REPORTS: 'dashboardIssueReports',
  GLOBAL_SEARCH: 'globalSearch',
  ZALO_INTEGRATION: 'zaloIntegration',
  BILLING: 'billing',
  STOREFRONT: 'storefront',
  STOREFRONT_POSTS: 'storefrontPosts',
  STOREFRONT_MESSAGES: 'storefrontMessages',
  STOREFRONT_BRANCHES: 'storefrontBranches',
};
